import { Box, Link, Text, Spacer } from '@chakra-ui/react';

function Footer() {
  return (
    <Box
      px={{ base: '12px', md: '72px' }}
      py="18px"
      columnGap="24px"
      bgColor="white"
      display="flex"
      alignItems="center"
      flexDir={{ base: 'column', md: 'row' }}
    >
      <Link>Privacy Policy</Link>
      <Link>Terms of Use</Link>
      <Spacer />
      <Text>© 2023 Smart School System</Text>
    </Box>
  );
}

export { Footer };
